import React from "react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";

const TimeField = ({ label, register, errors }: any) => {
  return (
    <div className={tw`w-full`}>
      <label className={tw`text-sm font-medium mb-1 block`}>{label}</label>

      <input
        type="time"
        step="1" 
        className={tw`w-full border rounded px-3 py-2`}
        {...register}
      />

      {errors && (
        <p className={tw`text-red-500 text-xs mt-1`}>{errors?.message}</p>
      )}
    </div>
  );
};

export default TimeField;
